/**
 * @fileoverview POST handler for the "/engagement/campaigns/clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsCloneCacheKeys } from "./constants";
import type { PostEngagementCampaignsCloneProps, EngagementCampaignsCloneResult } from "./types";

export const postEngagementCampaignsClone = reactQueryMutationAdapter(
  engagementCampaignsCloneCacheKeys,
  (props: PostEngagementCampaignsCloneProps): Promise<EngagementCampaignsCloneResult> => {
    return fetch("/engagement/campaigns/clone", "POST", props);
  }
);
